import { giphyBlue, giphyDarkCharcoal, giphyDarkGrey, giphyLightestGrey } from '@giphy/js-brand'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { ToolButton } from '../buttons'

const Button = styled(ToolButton)`
    align-items: center;
    background: ${giphyDarkCharcoal};
    color: ${giphyLightestGrey};
    display: flex;
    font-size: 16px;
    height: 34px;
    width: 100%;
`

const Label = styled.div`
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

const Preview = styled.div`
    border-radius: inherit;
    flex-shrink: 0;
    height: 100%;
    overflow: hidden;
    width: 34px;

    > * {
        display: block;
        height: 100%;
        width: 100%;
    }

    > img {
        object-fit: contain;
    }
`

const Arrow = styled.div`
    background: ${giphyDarkGrey};
    border-radius: inherit;
    color: ${giphyBlue};
    flex-shrink: 0;
    font-size: 14px;
    height: 100%;
    line-height: 38px;
    text-align: center;
    width: 34px;
`

type Props = {
    className?: string
    preview?: ReactNode
    label?: ReactNode
    onClick: () => void
}

const CreationToolsDropdownButton = ({ className, preview, label, onClick }: Props) => (
    <Button className={className} onClick={onClick}>
        {preview && <Preview>{preview}</Preview>}
        {label && <Label>{label}</Label>}
        <Arrow className="ss-dropdown" />
    </Button>
)

export default CreationToolsDropdownButton
